<ng-template [ngIf]="expanded" [ngIfElse]="collapsedMenu">
   <lcs-sliding-nav
      [data]="menuItems"
      [getChildren]="getChildren"
      [displayWith]="displayWith"
      [trackBy]="trackBy"
      [activeItem]="activeItem"
   >
      <li [class.spacer]="item.isSpacer" *lcsNavItemDef="let item">
         <div *ngIf="!item.isSpacer && !item.isHeader && !item.isDivider">
            <div class="lcs-nav-item" [class.indented]="item.isIndented" [hidden]="item.isHidden">
               <a
                  *ngIf="!item.isSpacer && !item.isHeader"
                  [routerLink]="item.routerLink"
                  [queryParams]="item.queryParams"
                  [queryParamsHandling]="item.queryParamsHandling"
                  routerLinkActive="active-page"
               >
                  <mat-icon *ngIf="item.icon">{{ item.icon }}</mat-icon>
                  <div class="nav-item-text menu-item-wrapper">
                     <div id="test" class="menu-item-title">{{ item.name }}</div>
                     <span class="menu-breadcrumbs text-accent">{{ item.breadCrumbText }}</span>
                  </div>
               </a>
            </div>
         </div>

         <a *ngIf="item.isHeader">
            <div class="nav-item-header" [class.indented]="item.isIndented" [hidden]="item.isHidden">
               {{ item.name }}
            </div>
         </a>

         <a *ngIf="item.isDivider">
            <mat-divider></mat-divider>
         </a>
      </li>

      <h2 lcsNavHeader *lcsNavHeaderDef="let section">{{ section.name }}</h2>

      <li
         [class.spacer]="item.isSpacer"
         lcs-nav-section
         *lcsNavSectionDef="let item"
         [class.indented]="item.isIndented"
         [hidden]="item.isHidden"
      >
         <mat-icon *ngIf="item.icon && !item.isSpacer">{{ item.icon }}</mat-icon>
         <div *ngIf="!item.isSpacer" class="nav-item-text menu-item-wrapper">
            <span class="menu-item-title">{{ item.name }}</span>
            <span class="menu-breadcrumbs text-accent">{{ item.breadCrumbText }}</span>
         </div>
      </li>
   </lcs-sliding-nav>
</ng-template>

<ng-template #collapsedMenu>
   <!-- Before additional menu items -->
   <ng-template ngFor [ngForOf]="collapsedMenuItems" let-item>
      <ng-template [ngIf]="item.children && item.children.length > 0" [ngIfElse]="link">
         <button
            class="nav-item"
            type="button"
            [matMenuTriggerFor]="nestedMenu.childMenu"
            [matMenuTriggerData]="{ $implicit: item.children }"
            [ndtRouteArea]="item.area"
            ndtRouteAreaActive="active-page"
            [matTooltip]="item.tooltip"
            matTooltipPosition="right"
         >
            <mat-icon>{{ item.icon }}</mat-icon>
            <span class="cdk-visually-hidden">{{ item.name }}</span>
         </button>
         <ndt-nested-menu #nestedMenu [items]="item.children"></ndt-nested-menu>
      </ng-template>

      <ng-template #link>
         <a
            class="nav-item"
            [routerLink]="item.routerLink"
            [queryParamsHandling]="item.queryParamsHandling"
            routerLinkActive="active-page"
            [matTooltip]="item.tooltip"
            matTooltipPosition="right"
         >
            <mat-icon *ngIf="item.icon">{{ item.icon }}</mat-icon>
            <span class="cdk-visually-hidden">{{ item.name }}</span>
         </a>
      </ng-template>
   </ng-template>

   <!-- Additional menu items -->
   <button
      class="nav-item"
      type="button"
      [matMenuTriggerFor]="moreMenu"
      matTooltip="More"
      matTooltipPosition="right"
      *ngIf="additionalMenuItems?.length > 0"
   >
      <mat-icon>more_horiz</mat-icon>
   </button>

   <!-- Spacer -->
   <div class="nav-item spacer"></div>

   <!-- After additional menu items -->
   <ng-template ngFor [ngForOf]="afterAdditionalMenuItems" let-item>
      <ng-template [ngIf]="item.children && item.children.length > 0" [ngIfElse]="link">
         <button
            class="nav-item"
            type="button"
            [matMenuTriggerFor]="nestedMenu.childMenu"
            [matMenuTriggerData]="{ $implicit: item.children }"
            [ndtRouteArea]="item.area"
            ndtRouteAreaActive="active-page"
            [matTooltip]="item.tooltip"
            matTooltipPosition="right"
         >
            <mat-icon>{{ item.icon }}</mat-icon>
            <span class="cdk-visually-hidden">{{ item.name }}</span>
         </button>
         <ndt-nested-menu #nestedMenu [items]="item.children"></ndt-nested-menu>
      </ng-template>

      <ng-template #link>
         <a
            class="nav-item"
            [routerLink]="item.routerLink"
            [queryParamsHandling]="item.queryParamsHandling"
            routerLinkActive="active-page"
            [matTooltip]="item.tooltip"
            matTooltipPosition="right"
         >
            <mat-icon *ngIf="item.icon">{{ item.icon }}</mat-icon>
            <span class="cdk-visually-hidden">{{ item.name }}</span>
         </a>
      </ng-template>
   </ng-template>

   <mat-menu #moreMenu="matMenu" class="additional-menu-items">
      <ng-template matMenuContent>
         <a
            *ngFor="let item of additionalMenuItems"
            [routerLink]="item.routerLink"
            [queryParamsHandling]="item.queryParamsHandling"
            ndtMenuItemActive="active-page"
            [matTooltip]="item.tooltip"
            matTooltipPosition="right"
            mat-menu-item
         >
            <mat-icon *ngIf="item.icon">{{ item.icon }}</mat-icon>
            <span>{{ item.name }}</span>
            <span>{{ item.breadCrumbText }}</span>
         </a>
      </ng-template>
   </mat-menu>
</ng-template>
